// @Author https://github.com/maxogden/browser-locale/
export const browserLocale = () => {
  let lang: string;

  if (navigator.languages && navigator.languages.length) {
    // latest versions of Chrome and Firefox set this correctly
    lang = navigator.languages[0];
  } else {
    // latest versions of Chrome, Firefox, and Safari set this correctly
    lang = navigator.language;
  }

  return lang;
};

window.browserLocale = browserLocale;
